import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { LAPTOP_MEDIA_QUERY } from '../../../common/components/utils/constants';

const SELECTORS = {
	reserveButton: '#reserve',
	reserveContainer: '.clinic-booking-form',
	closeButton: '.clinic__booking-close',
};

export class ReserveBooking {
	constructor() {
		this.reserveButton = document.querySelector(SELECTORS.reserveButton);
		this.reserveElement = document.querySelector(SELECTORS.reserveContainer);
		this.closeButton = document.querySelector(SELECTORS.closeButton);

		const requiredElements = [this.reserveElement, this.reserveButton, this.closeButton];
		if (requiredElements.some((ele) => !ele)) {
			throw new Error('Reserve booking is not initialized');
		}

		this.isActive = false;

		this.mediaQuery = window.matchMedia(LAPTOP_MEDIA_QUERY);

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line no-unused-vars
		const reserveBooking = new ReserveBooking();
	}

	/**
	 * Bind `this` explicitly for event listeners.
	 */
	bindEvents() {
		[
			'onHideBooking',
			'onShowBooking',
			'onMoveBookingDown',
			'onMediaQueryChange',
			'moveBookingUp',
		].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	moveBookingUp() {
		this.reserveElement.style.transform = 'translateY(0)';
	}

	onShowBooking() {
		this.reserveElement.style.display = 'block';
		setTimeout(this.moveBookingUp, 0);
		disableBodyScroll(this.reserveElement);
	}

	onMoveBookingDown() {
		this.isActive = true;
		this.reserveElement.style.transform = 'translateY(100%)';
		enableBodyScroll(this.reserveElement);
	}

	onHideBooking() {
		if (this.isActive) {
			this.reserveElement.style.display = 'none';
			this.isActive = false;
		}
	}

	resetStyle() {
		this.reserveElement.removeAttribute('style');
		enableBodyScroll(this.reserveElement);
	}

	onMediaQueryChange(e) {
		if (!e.matches) {
			this.resetStyle();
			this.destroy();
		} else {
			this.reserveElement.style.display = 'none';
			this.setupEventListeners();
		}
	}

	setupEventListeners() {
		this.reserveElement.addEventListener('transitionend', this.onHideBooking);
		this.reserveButton.addEventListener('click', this.onShowBooking);
		this.closeButton.addEventListener('click', this.onMoveBookingDown);
	}

	setup() {
		this.mediaQuery.addEventListener('change', this.onMediaQueryChange);
		this.setupEventListeners();
	}

	destroy() {
		this.reserveElement.removeEventListener('transitioned', this.onHideBooking);
		this.reserveButton.removeEventListener('click', this.onShowBooking);
		this.closeButton.removeEventListener('click', this.onMoveBookingDown);
	}
}
